<template>
  <div class="row">
    <div class="column twelve">
      <div class="relative mx-auto rounded shadow search-input-container block z-5">

        <!-- Search Field -->
        <div class="flex w-full">
          <input
              class="search-input"
              type="text"
              :value="query"
              @input="$emit('update-query', $event.currentTarget.value)"
              placeholder="Search by address, zip, city, or county"
          />
          <button class="search-input-button icon-m-search" aria-label="Search"></button>
        </div>

        <!-- Filter Bar -->
        <div class="border-t border-gray100 border-solid flex flex-wrap">

          <!-- Ownership -->
          <div
              class="listing-filter-category px-25 py-30 cursor-pointer relative"
              :class="{ active: openDropdown === 'ownership' }"
              @click="toggleDropdown('ownership')"
          >
            <div class="text-gray600 mr-15">Ownership</div>
            <div class="listing-filter-category-dropdown-arrow"></div>
            <div class="listing-filter-options" v-show="openDropdown === 'ownership'" @click.stop>
              <div class="flex flex-col items-start p-40 bg-white rounded w-300">
                <div class="w-full">
                  <div v-for="item in ownershipItems" :key="item.label" class="py-8">
                    <label class="check-container flex items-center cursor-pointer">
                      {{ item.label }}
                      <span v-if="item.count" class="ml-5 text-gray400">({{ item.count }})</span>
                      <input
                          type="checkbox"
                          :checked="item.isRefined ? true : null"
                          @change="$emit('toggle-refinement', 'ownership', item.value)"
                          class="hidden"
                      />
                      <span
                          class="trans checkmark rounded-lg border-gray100 flex items-center justify-center p-1 listing-search-input-container"
                          style="width: 25px; margin-left: auto;"
                      >
                        <span
                            class="icon-s-check text-blue500"
                            :style="{ display: item.isRefined ? 'inline' : 'none', position: 'relative', top: '-1px' }"
                        ></span>
                      </span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Type -->
          <div
              class="listing-filter-category px-25 py-30 cursor-pointer relative"
              :class="{ active: openDropdown === 'type' }"
              @click="toggleDropdown('type')"
          >
            <div class="text-gray600 mr-15">Type</div>
            <div class="listing-filter-category-dropdown-arrow"></div>
            <div class="listing-filter-options" v-show="openDropdown === 'type'" @click.stop>
              <div class="flex flex-col items-start p-40 bg-white rounded w-300">
                <div class="w-full">
                  <div v-for="item in typeItems" :key="item.label" class="py-8">
                    <label class="check-container flex items-center cursor-pointer">
                      {{ item.label }}
                      <span v-if="item.count" class="ml-5 text-gray400">({{ item.count }})</span>
                      <input
                          type="checkbox"
                          :checked="item.isRefined ? true : null"
                          @change="$emit('toggle-refinement', 'type', item.value)"
                          class="hidden"
                      />
                      <span
                          class="trans checkmark rounded-lg border-gray100 flex items-center justify-center p-1 listing-search-input-container"
                          style="width: 25px; margin-left: auto;"
                      >
                        <span
                            class="icon-s-check text-blue500"
                            :style="{ display: item.isRefined ? 'inline' : 'none', position: 'relative', top: '-1px' }"
                        ></span>
                      </span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Square Footage -->
          <div
              class="listing-filter-category px-25 py-30 cursor-pointer relative"
              :class="{ active: openDropdown === 'sqft' }"
              @click="toggleDropdown('sqft')"
          >
            <div class="text-gray600 mr-15">Square Ft</div>
            <div class="listing-filter-category-dropdown-arrow"></div>
            <div class="listing-filter-options" v-show="openDropdown === 'sqft'" @click.stop>
              <div class="flex items-center p-40 bg-white rounded">
                <div class="flex flex-col items-start bg-white rounded w-300">
                  <label
                      v-for="item in sqftOptions"
                      :key="item.value"
                      class="check-container flex items-center cursor-pointer py-8 w-full"
                      @click="$emit('update-sqft-range', item.value)"
                  >
                    <span class="mr-auto">{{ item.label }}</span>
                    <span
                        class="trans checkmark rounded-lg border-gray100 flex items-center justify-center p-1 listing-search-input-container"
                        style="width: 25px;"
                    >
                      <span
                          class="icon-s-check text-blue500"
                          v-show="item.value === sqftRange"
                          style="position: relative; top: -1px"
                      ></span>
                    </span>
                  </label>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Brokerage search controls for text, ownership, venue type, and square footage.
export default {
  props: {
    query: {
      type: String,
      default: '',
    },
    ownershipItems: {
      type: Array,
      default: () => [],
    },
    typeItems: {
      type: Array,
      default: () => [],
    },
    sqftRange: {
      type: String,
      default: 'any',
    },
  },
  emits: ['update-query', 'toggle-refinement', 'update-sqft-range'],
  data() {
    return {
      openDropdown: null,
      sqftOptions: [
        { label: 'Any', value: 'any' },
        { label: 'Under 5,000 sf', value: 'under5000' },
        { label: '5,000 - 10,000 sf', value: '5000-10000' },
        { label: 'Over 10,000 sf', value: 'over10000' },
      ],
    };
  },
  methods: {
    toggleDropdown(name) {
      this.openDropdown = this.openDropdown === name ? null : name;
    },
    closeDropdownOnClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.openDropdown = null;
      }
    }
  },
  mounted() {
    document.addEventListener('click', this.closeDropdownOnClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.closeDropdownOnClickOutside);
  },
};
</script>
